import { i18next } from '@yola/ws-sdk';
import getMediaCornersSettings from './get-media-corners-settings';
import getColumnCornersSettings from './get-column-corners-settings';

const getOtherStylesSections = () => [
  {
    id: 'columns',
    title: i18next.t('Columns'),
    options: [
      {
        id: 'corners',
        title: i18next.t('Corners'),
        options: [getColumnCornersSettings()],
      },
    ],
  },
  {
    id: 'media',
    title: i18next.t('Media'),
    options: [
      {
        id: 'corners',
        title: i18next.t('Corners'),
        options: [getMediaCornersSettings()],
      },
    ],
  },
];

export default getOtherStylesSections;
